(function ($) {
  $(document).ready(function () {
    const vacancies_script = localizedData.vacancies_script;

    $(".apply-now-btn").on("click", function (e) {
      e.preventDefault();
      $("#vacancy-form-popup-wrapper").show();
      const vacancy_id = $(this).data("vacancy-id");
      $.ajax({
        url: vacancies_script.ajax_url,
        method: "POST",
        dataType: "json",
        data: {
          action: vacancies_script.vacancy_show_form_action,
          nonce: vacancies_script.vacancy_form_token,
          vacancy_id: vacancy_id,
        },
        success: function (response) {
          if (response.success && response.data.html) {
            $("#vacancy-form-popup-wrapper").html(response.data.html);

            initializeDragAndDrop();
            if (typeof grecaptcha !== "undefined") {
              grecaptcha.ready(function () {
                window.recaptchaWidgetId = grecaptcha.render(
                  $(".g-recaptcha")[0],
                  {
                    sitekey: vacancies_script.google_recaptcha_site_key,
                  }
                );
              });
            }
          } else {
            console.error("Unexpected response:", response);
          }
        },
        error: function (err) {
          console.error("AJAX error:", err);
        },
      });
    });

    $(document).on("click", ".apply-now-form-close", function () {
      $("#vacancy-form-popup-wrapper").hide();
    });

    $(document).on("change", "#job-position", function () {
      var jobPosition = $(this).find("option:selected").text();
      $("#job-position-title").html(" - " + jobPosition);
    });

    function initializeDragAndDrop() {
      const maxFileSize = 10 * 1024 * 1024; // 10MB
      const allowedFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      const firstNameStatus = $("#first-name-status");
      const lastNameStatus = $("#last-name-status");
      const emailStatus = $("#email-status");

      const resumeInput = $("#resume-upload-form-input");
      const resumeDropArea = $("#drag-and-drop-area");
      const resumeStatus = $("#resume-status");
      const resumePreview = $("#resume-preview");

      const otherDocsInput = $("#other-docs-upload-input");
      const otherDocsDropArea = $("#drag-and-drop-other-docs");
      const otherDocsStatus = $("#other-docs-status");
      const otherDocsPreview = $("#other-docs-preview");

      let resumeFiles = [];
      let otherDocsFiles = [];

      function handleFiles(files, targetType) {
        let validFiles = [];
        let invalidFiles = [];
        let invalidFileTypes = [];

        const status = targetType === "resume" ? resumeStatus : otherDocsStatus;
        const preview =
          targetType === "resume" ? resumePreview : otherDocsPreview;
        const storage = targetType === "resume" ? resumeFiles : otherDocsFiles;

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.size > maxFileSize) {
            invalidFiles.push(file.name);
          } else if (!allowedFileTypes.includes(file.type)) {
            invalidFileTypes.push(file.name);
          } else {
            validFiles.push(file);
          }
        }

        if (invalidFiles.length > 0) {
          status
            .text(`Files too large: ${invalidFiles.join(", ")}`)
            .css("color", "red");
        } else if (invalidFileTypes.length > 0) {
          status
            .text(`Invalid file types: ${invalidFileTypes.join(", ")}`)
            .css("color", "red");
        } else {
          status.text("").css("color", "");
        }

        if (validFiles.length > 0) {
          storage.length = 0; // Clear previous files
          storage.push(...validFiles);
          preview.empty();

          validFiles.forEach((file) => {
            const wrapper = $("<div>").addClass("file-preview-wrapper");
            const icon = $("<span>")
              .text(file.name)
              .css({ display: "inline-block" });

            const cancelBtn = $("<button>")
              .text("X")
              .addClass("cancel-btn")
              .on("click", function () {
                const index = storage.findIndex((f) => f.name === file.name);
                if (index !== -1) {
                  storage.splice(index, 1);
                  wrapper.remove();

                  // Reset the input to allow re-uploading the same file
                  if (targetType === "resume") {
                    resumeInput.val(""); // Reset resume input
                  } else {
                    otherDocsInput.val(""); // Reset other docs input
                  }
                }
              });

            wrapper.append(icon).append(cancelBtn);
            preview.append(wrapper);
          });
        }
      }

      function bindInputEvents(input, area, targetType) {
        input.on("change", function () {
          handleFiles(this.files, targetType);
        });

        area.on("dragover", function (e) {
          e.preventDefault();
          e.stopPropagation();
          area.addClass("drag-over");
        });

        area.on("dragleave", function (e) {
          e.preventDefault();
          e.stopPropagation();
          area.removeClass("drag-over");
        });

        area.on("drop", function (e) {
          e.preventDefault();
          e.stopPropagation();
          area.removeClass("drag-over");

          const files = e.originalEvent.dataTransfer.files;

          // Directly handle files instead of triggering change
          handleFiles(files, targetType);

          // If you want to preserve the dropped files in the input field visually:
          const dataTransfer = new DataTransfer();
          for (const file of files) {
            dataTransfer.items.add(file);
          }
          input[0].files = dataTransfer.files;
        });
      }

      bindInputEvents(resumeInput, resumeDropArea, "resume");
      bindInputEvents(otherDocsInput, otherDocsDropArea, "otherDocs");

      $(document).on("submit", "#vacancy-form", function (e) {
        e.preventDefault(); // Prevent form submission to handle it via AJAX

        // Get form field values
        let firstName = $("#first-name").val().trim();
        let lastName = $("#last-name").val().trim();
        let email = $("#email").val().trim();

        let hasError = false;

        firstNameStatus.text("");
        lastNameStatus.text("");
        emailStatus.text("");
        resumeStatus.text("");

        // Clear previous error messages
        $(".error-message").text("");

        // Character limits
        const maxNameLength = 50;
        const maxEmailLength = 100;

        // Validate first name
        if (!firstName) {
          firstNameStatus.text("First name is required.").css("color", "red");
          hasError = true;
        } else if (firstName.length > maxNameLength) {
          firstNameStatus
            .text("First name cannot exceed " + maxNameLength + " characters.")
            .css("color", "red");
          hasError = true;
        }

        // Validate last name
        if (!lastName) {
          lastNameStatus.text("Last name is required.").css("color", "red");
          hasError = true;
        } else if (lastName.length > maxNameLength) {
          lastNameStatus
            .text("Last name cannot exceed " + maxNameLength + " characters.")
            .css("color", "red");
          hasError = true;
        }

        // Validate email
        if (!email) {
          emailStatus.text("Email is required.").css("color", "red");
          hasError = true;
        } else if (email.length > maxEmailLength) {
          emailStatus
            .text("Email cannot exceed " + maxEmailLength + " characters.")
            .css("color", "red");
          hasError = true;
        } else {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(email)) {
            emailStatus
              .text("Please enter a valid email address.")
              .css("color", "red");
            hasError = true;
          }
        }

        // Validate resume
        if (resumeFiles.length === 0) {
          resumeStatus.text("Please upload your resume.").css("color", "red");
          hasError = true;
        } else {
          const file = resumeFiles[0]; // Expecting only one resume
          if (file.size > maxFileSize) {
            resumeStatus
              .text("Resume file size exceeds 10 MB.")
              .css("color", "red");
            hasError = true;
          } else if (!allowedFileTypes.includes(file.type)) {
            resumeStatus
              .text("Resume must be a PDF or Word document.")
              .css("color", "red");
            hasError = true;
          }
        }

        let recaptcha = grecaptcha.getResponse(window.recaptchaWidgetId);

        if (recaptcha === "") {
          $(".recaptcha-error")
            .text("Please verify that you are not a robot.")
            .css("color", "red");
          hasError = true;
        }

        if (hasError) {
          return; // Stop submission
        }

        // Prepare form data
        const formData = new FormData(this); // Add form fields to formData

        // Append files to form data
        resumeFiles.forEach((file) => formData.append("resume[]", file));
        otherDocsFiles.forEach((file) => formData.append("other_docs[]", file));

        // Add action and nonce for security
        formData.append(
          "action",
          vacancies_script.submit_vacancy_application_action,
        );
        formData.append("nonce", vacancies_script.vacancy_form_submit_token);

        // Send AJAX request
        $.ajax({
          url: vacancies_script.ajax_url,
          method: "POST",
          data: formData,
          processData: false,
          contentType: false,
          beforeSend: function () {
            $("#vacancy-apply-loader").show(); // Show loader
            $("#vacancy-form :input").prop("disabled", true); // Disable form inputs
          },

          success: function (response) {
            let statusEl = $("#form-status");
            if (statusEl.length === 0) {
              statusEl = $(
                '<div id="form-status" class="form-status"></div>',
              ).appendTo("body");
            }

            statusEl.removeClass("success error");

            if (response.success) {
              statusEl
                .html(
                  '<i class="fa-solid fa-check"></i> Application submitted successfully!',
                )
                .addClass("success")
                .fadeIn();
              $("#vacancy-form")[0].reset();
              $("#vacancy-form-popup-wrapper").hide();
              resumeFiles = [];
              otherDocsFiles = [];
              resumePreview.empty();
              otherDocsPreview.empty();
            } else {
              statusEl
                .html(
                  '<i class="fa-solid fa-triangle-exclamation"></i> Submission failed: ' +
                    response.message,
                )
                .addClass("error")
                .fadeIn();
            }
            setTimeout(() => statusEl.fadeOut(), 5000);
          },
          error: function () {
            // If AJAX fails, show error message
            $("#form-status")
              .text("Submission failed. Please try again.")
              .css("color", "red");
          },
          complete: function () {
            $("#vacancy-apply-loader").hide(); // Hide loader
            $("#vacancy-form :input").prop("disabled", false); // Enable form inputs again

            grecaptcha.reset(window.recaptchaWidgetId);
          },
        });
      });

      $(document).on("click", ".reset-vacancy-form", function (e) {
        e.preventDefault();
        var title = $("#input-job-position-title").val();
        // Reset the form fields
        $("#vacancy-form")[0].reset();

        // Clear previews
        $("#resume-preview").empty();
        $("#other-docs-preview").empty();

        // Clear file arrays if you're tracking them
        resumeFiles = [];
        otherDocsFiles = [];

        // Clear error messages
        $(".error-message").text("");
        $("#form-status").text("");

        // Optionally reset job position title
        $("#job-position-title").html(" - " + title);
      });
    }
  });
})(jQuery);
